import { motion } from "framer-motion";
import { BadgeCheck, Info, Newspaper } from "lucide-react";

export const AboutNews = ({ news }) => (
  <section id="about" data-testid="about-section" className="mx-auto max-w-7xl scroll-mt-28 px-4 py-20 sm:px-6 lg:px-12">
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
      <motion.div
        data-testid="about-block"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7 }}
        className="glass gold-sheen rounded-2xl p-7"
      >
        <div className="mb-4 flex items-center gap-2 text-amber-300">
          <Info className="h-4 w-4" />
          <h3 className="text-base font-bold">درباره ما</h3>
        </div>
        <p className="text-sm font-light leading-8 text-stone-400">
          سکه کازرانی با سال‌ها تجربه در خرید و فروش سکه، طلا و جواهر، در نبش خیابان ولیعصر فعالیت می‌کند. اصالت کالا، دقت در وزن‌کشی و شفافیت نرخ، اصل کار ماست.
        </p>
        <div data-testid="license-badge" className="mt-5 flex items-center gap-2 rounded-lg border border-amber-500/25 bg-amber-500/5 px-3 py-2.5 text-[11px] text-amber-200/80">
          <BadgeCheck className="h-4 w-4 shrink-0 text-amber-400" />
          مجوز رسمی اتحادیه طلا، جواهر و نقره تهران
        </div>
      </motion.div>

      <motion.div
        data-testid="licenses-block"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay: 0.12 }}
        className="glass gold-sheen rounded-2xl p-7"
      >
        <div className="mb-4 flex items-center gap-2 text-amber-300">
          <BadgeCheck className="h-4 w-4" />
          <h3 className="text-base font-bold">مجوزها</h3>
        </div>
        <p className="text-sm font-light leading-8 text-stone-400">
          فعالیت این مجموعه با مجوز رسمی از اتحادیه طلا، جواهر و نقره تهران انجام می‌شود. تصویر و شماره مجوز به‌درخواست مشتریان در محل مغازه قابل مشاهده است.
        </p>
      </motion.div>

      <motion.div
        data-testid="news-section"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay: 0.24 }}
        className="glass gold-sheen rounded-2xl p-7"
      >
        <div className="mb-4 flex items-center gap-2 text-amber-300">
          <Newspaper className="h-4 w-4" />
          <h3 className="text-base font-bold">اخبار و اطلاعیه‌ها</h3>
        </div>
        <div className="space-y-3">
          {(news?.length ? news : []).map((n, i) => (
            <div key={i} data-testid={`news-card-${i + 1}`} className="flex items-start gap-3 rounded-lg border border-amber-500/10 bg-black/30 px-3 py-2.5">
              <span className="shrink-0 rounded-full bg-amber-500/15 px-2.5 py-0.5 text-[10px] text-amber-300">{n.tag}</span>
              <span className="text-xs leading-6 text-stone-300">{n.title}</span>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
